import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import {
  MdDashboard,
  MdOutlineRoute,
  MdHouseSiding,
  MdOutlineTour,
  MdOutlineDescription,
  MdOutlineDataThresholding,
  MdHelpOutline,
  MdMenu,
  MdOutlineContactPage,
} from 'react-icons/md';
import { BiTag } from 'react-icons/bi';
import { AdminIcon } from '../Icons/Icons';
import { getRoleChecks } from '../../utils/roles';
import Icon from '../Icons/Icon';

import MenuItem from './MenuItem';

const Navbar = ({ currentUserRole, isDefaultExpand = false }) => {
  const [isNavbarExpanded, setIsNavbarExpanded] = useState(isDefaultExpand);

  const { isManager } = getRoleChecks(currentUserRole);
  const menuItems = [
    {
      icon: <MdDashboard size={24} className="text-vamos-green1" />,
      title: 'Dashboard',
      link: '/',
    },
    {
      icon: <MdOutlineRoute size={24} className="text-vamos-green1" />,
      title: 'Routes',
      link: '/routes',
    },
    {
      icon: <MdHouseSiding size={24} className="text-vamos-green1" />,
      title: 'Sites',
      link: '/sites',
    },
    {
      icon: <MdOutlineTour size={24} className="text-vamos-green1" />,
      title: 'Visits',
      link: '/visits',
    },
    {
      icon: <MdOutlineDescription size={24} className="text-vamos-green1" />,
      title: 'Notes',
      link: '/notes',
    },
    {
      icon: <MdOutlineContactPage size={24} className="text-vamos-green1" />,
      title: 'Contacts',
      link: '/contacts',
    },
    {
      icon: <BiTag size={24} className="text-vamos-green1 scale-x-[-1]" />,
      title: 'Tags',
      link: '/tags',
    },
    isManager && {
      icon: <MdOutlineDataThresholding size={24} className="text-vamos-green1" />,
      title: 'Import',
      link: '/imports',
    },
    isManager && {
      icon: <Icon name="export" />,
      title: 'Export',
      link: '/reports',
    },
    {
      icon: <AdminIcon className="text-vamos-green1" width={24} height={24} />,
      title: 'Admin',
      link: '/admin',
    },
    {
      icon: <MdHelpOutline
        size={24}
        className="text-vamos-green1"
      />,
      title: 'Help',
      link: '/help',
    },
  ].filter(Boolean); // it will filter out any falsy values (like the isManager check)

  const overflowClass = isNavbarExpanded ? 'overflow-auto' : '';
  const widthClass = isNavbarExpanded ? 'w-67.75 shadow-vamos-drop-shadow' : 'w-20';

  return (
    <nav
      aria-label="navigation bar"
      className={`fixed ${overflowClass} z-50 top-16 bottom-0 bg-vamos-true-white ${widthClass} transition-all duration-200 ease-out`}
      onMouseEnter={() => setIsNavbarExpanded(true)}
      onMouseLeave={() => setIsNavbarExpanded(false)}
    >
      <div className="pt-3 pb-7 px-6 focus:outline-none"><MdMenu size={24} /></div>
      <ul>
        {menuItems.map((item) => (
          <MenuItem
            key={item.title}
            isNavbarExpanded={isNavbarExpanded}
            icon={item.icon}
            title={item.title}
            link={item.link}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;

export const navbarIcons = [
  { Component: MdDashboard, label: 'Dashboard' },
  { Component: MdOutlineRoute, label: 'Routes' },
  { Component: MdHouseSiding, label: 'Sites' },
  { Component: MdOutlineTour, label: 'Visits' },
  { Component: MdOutlineDescription, label: 'Notes' },
  { Component: MdOutlineDataThresholding, label: 'Import' },
  { Component: <Icon name="export" />, label: 'Export' },
  { Component: MdHelpOutline, label: 'Help' },
  { Component: MdMenu, label: 'Menu' },
  { Component: MdOutlineContactPage, label: 'Contacts' },
  { Component: BiTag, label: 'Tags' },
];

Navbar.propTypes = {
  currentUserRole: PropTypes.string.isRequired,
  isDefaultExpand: PropTypes.bool,
};
